import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// import { Headers, RequestOptions } from '@angular/common/http';
import { EnvVariables } from '../../environments/environment';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { AlertController, ToastController } from 'ionic-angular';
import { Clipboard } from '@capacitor/clipboard';

import * as debug from 'debug';
import * as _ from 'lodash';

@Injectable()
export class CrudApiProvider {
  log = debug('app:CrudApiProvider');

  static authKey: string;
  static store: any;

  baseUrlv2: string;
  baseUrl: string;

  alertedLostConnection = false;
  alertInterval: any = null;
  allowToast = true;
  alertClosed = false;
  alertCount = 0;
  encryptionUUID = '818774c0-795c-4826-bb46-24cd0d34a9e7';

  constructor(
    public http: HttpClient,
    public env: EnvVariables,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController
  ) {
    this.baseUrl = this.env.apiURL;
    this.baseUrlv2 = this.env.apiURLv2;
    this.encryptionUUID =
      this.env.simpleEncryptionUUID || '818774c0-795c-4826-bb46-24cd0d34a9e7';

    this.checkClipboardAuth();

    try {
      CrudApiProvider.authKey =
        JSON.parse(localStorage.getItem('APP_AUTH_KEY')) || '';
    } catch (e) {
      CrudApiProvider.authKey = '';
    }
  }

  async simpleLocalEncrypt(s: string): Promise<string> {
    const cryptoJS = window['CryptoJS'];
    return cryptoJS.AES.encrypt(s, this.encryptionUUID).toString();
  }

  async simpleLocalDecrypt(s: string): Promise<string> {
    const cryptoJS = window['CryptoJS'];
    return cryptoJS.AES.decrypt(s, this.encryptionUUID).toString(
      cryptoJS.enc.Utf8
    );
  }

  async checkClipboardAuth() {
    if (localStorage.getItem('APP_AUTH_KEY'))
      try {
        const turnkeyRegex = new RegExp('cma=');
        if (!localStorage.getItem('APP_AUTH_KEY')) {
          const clipboard = await Clipboard.read();
          const value = await this.simpleLocalDecrypt(clipboard.value);
          if (turnkeyRegex.test(value)) {
            console.warn('clipboard', value);
            const appToken = _.split(value, 'cma=');
            console.warn('appToken', appToken);
            localStorage.setItem('APP_AUTH_KEY', `"${appToken[1]}"`);
            Clipboard.write({ string: '' }); // clear clipboard
            document.location.reload();
          }
        }
      } catch (e) {}
  }

  get(url: string, query: any = {}) {
    const headers = this.getHeaders(),
      options = { headers: headers };

    url = this.addQuery(this.createURL(url), query || {});

    return this.http
      .get(this.getUrl(url), options)
      .toPromise()
      .then(this.parseResponse)
      .catch(e => {
        this.log('CrudError GET', url, e);
        return Promise.reject(e);
      });
  }

  post(url: string, data?: any) {
    const headers = this.getHeaders(),
      options = { headers: headers };

    return this.http
      .post(this.getUrl(this.createURL(url)), data, options)
      .toPromise()
      .then(this.parseResponse)
      .catch(e => {
        this.log('CrudError POST', url, e);
        return Promise.reject(e);
      });
  }

  put(url: string, data?: any) {
    const headers = this.getHeaders(),
      options = { headers: headers };

    return this.http
      .put(this.getUrl(this.createURL(url)), data, options)
      .toPromise()
      .then(this.parseResponse)
      .catch(e => {
        this.log('CrudError PUT', url, e);
        return Promise.reject(e);
      });
  }

  delete(url: string, data?: any) {
    const headers = this.getHeaders(),
      options = { headers: headers };

    return this.http
      .delete(this.getUrl(this.createURL(url)), options)
      .toPromise()
      .then(this.parseResponse)
      .catch(e => {
        this.log('CrudError DELETE', url, e);
        return Promise.reject(e);
      });
  }

  fireTrackingPixel(src, options) {
    return this.http
      .get(src, options)
      .toPromise()
      .then()
      .catch(e => {});
  }

  addQuery(url: string, query: any): string {
    if (/\?/.test(url)) {
      url += '&';
    } else {
      url += '?';
    }

    return url + this.serialize(query);
  }

  private getUrl(url: string): string {
    return this.addQuery(url, {});
  }

  private getHeaders() {
    return {
      'Turnkey-Auth': CrudApiProvider.authKey || '',
    };
  }

  private serialize(obj: any, prefix?) {
    const str = [];
    let k, v;
    for (const p in obj) {
      if (obj.hasOwnProperty(p)) {
        k = prefix ? prefix + '[' + p + ']' : p;
        v = obj[p];
        if (v instanceof Date) {
          v = JSON.stringify(v);
        }
        str.push(
          typeof v === 'object'
            ? this.serialize(v, k)
            : encodeURIComponent(k) + '=' + encodeURIComponent(v)
        );
      }
    }
    return str.join('&');
  }

  private parseResponse(d): any {
    _.set(this, 'alertInterval', 0);

    if (d.error) {
      return Promise.reject(d.error);
    } else {
      return { data: d.data, metadata: d.metadata };
    }
  }

  private createURL(u) {
    if (/^http/i.test(u)) {
      return u;
    } else {
      if (/v2\/lc/.test(u) && this.baseUrlv2) {
        this.log('using v2 api', u);
        return `${this.baseUrlv2}${u}`;
      } else {
        return `${this.baseUrl}${u}`;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/crud-api/crud-api.ts